import { useState } from "react";
import { JOB_STEPS } from "../CreateJobPage";
import ManualDraftForm from "./ManualDraftForm";
import ImportRequirementForm from "./ImportRequirementForm";

const postTypes = [
  {
    label: "Import a partnered hiring-company requirement",
    desc: "Use requirement details already shared with your agency, then review every field before publishing.",
    value: 1,
    isRecommended: true,
  },
  {
    label: "Start a new job post manually",
    desc: "Build the role, candidate-facing content and contextual skill requirements from a blank draft.",
    value: 2,
  },
];

const Step1 = ({ activeStep }) => {
  const [selectedPostType, setSelectedPostType] = useState(1);

  return (
    <>
      <div className="flex border-b pb-3">
        <div className="flex flex-col gap-0.5 flex-1">
          <span className="text-xss font-bold text-light-black uppercase">
            Step {String(activeStep).padStart(2, "0")} /{" "}
            {JOB_STEPS[activeStep - 1]?.label}{" "}
          </span>
          <span className="font-semibold text-xl">
            {JOB_STEPS[activeStep - 1]?.title}
          </span>
          <span className="text-xss font-medium text-light-black">
            {JOB_STEPS[activeStep - 1]?.subtitle}
          </span>
        </div>
        <span className="self-end text-xss font-bold text-light-black uppercase leading-3">
          {JOB_STEPS[activeStep - 1]?.tagline}
        </span>
      </div>

      {/* Post Type */}
      <div className="flex my-5 gap-3">
        {postTypes?.map((postType) => {
          const isSelected = postType?.value === selectedPostType;
          return (
            <button
              onClick={() => setSelectedPostType(postType?.value)}
              className={`flex rounded-md p-4 gap-3 flex-1 ${isSelected ? "border-l-[3.5px] border-slate-600 border bg-slate-50" : "border"}`}
            >
              <div className="rounded-full border w-4 h-4 shrink-0 border-light-grey"></div>
              <div className="flex flex-col gap-1 flex-1 text-left">
                <span className="text-black text-sm font-semibold">
                  {postType?.label}
                </span>
                <span className="text-xss text-light-black font-medium">
                  {postType?.desc}
                </span>
              </div>
              {postType?.isRecommended ? (
                <div className="bg-green-100 text-green-800 rounded-full py-0.5 px-3 uppercase font-bold text-xss w-max h-max">
                  recommended
                </div>
              ) : null}
            </button>
          );
        })}
      </div>

      {selectedPostType === 1 ? <ImportRequirementForm /> : <ManualDraftForm />}
    </>
  );
};

export default Step1;
